import {
  GET_DPP_YN,
  GET_DPP_YN_SUCCESS,
  SET_ADM_EMAIL_MANAGEMENT_ALERT_MESSAGE,
  SET_ADM_EMAIL_MANAGEMENT_ERROR,
  SET_ADM_EMAIL_MANAGEMENT_LOADING,
  SET_ADM_EMAIL_MANAGEMENT_SUCCESS,
  UPDATE_DPP_YN,
  UPDATE_DPP_YN_SUCCESS
} from "./actionTypes"

const initialState = {
  loading: false,
  success: "",
  alertMsg: "",
  error: "",
  dppYn: false,
}

const AdminEmailManagement = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADM_EMAIL_MANAGEMENT_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case SET_ADM_EMAIL_MANAGEMENT_SUCCESS:
      return {
        ...state,
        success: action.payload,
      }
    case SET_ADM_EMAIL_MANAGEMENT_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case SET_ADM_EMAIL_MANAGEMENT_ALERT_MESSAGE:
      return {
        ...state,
        alertMsg: action.payload,
      }
    case GET_DPP_YN:
      return {
        ...state,
        loading: true,
      }
    case GET_DPP_YN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "",
        error: "",
        alertMsg: "",
        dppYn: action.payload.dppYn === "Y"
      }
    case UPDATE_DPP_YN:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_DPP_YN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        error: action.payload.error,
        dppYn: action.payload.success === "Success" ? action.payload.dppYn === "Y" : state.dppYn
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default AdminEmailManagement;
